module.exports = __webpack_public_path__ + "img/mainmenbuttonLH.09d1f470.png";